import request from "../utils/request";

export function index(params = {}) {
  return request({
    url: "khucongnghieps",
    method: "get",
    params,
  });
}